import * as React from "react";
import { RuntimeTheme } from "../../../lib/theme/theme";
import { ThemeProvider, withTheme } from "styled-components";
import { smallTitlesOverlay } from "../../../lib/theme/theme-overlays/small-titles-overlay";
import { mergeTheme } from "sharedUI/lib/theme-utils";
import { TailwindThemeProvider } from "sharedUI/lib/tailwind-theme-provider";

interface Props {
    readonly theme: RuntimeTheme;
    readonly useLargeTitles: boolean;
    readonly updateTailwind?: boolean;
    readonly children?: React.ReactNode;
}

class ThemeContainer extends React.PureComponent<Props> {
    public render(): React.ReactNode {
        let theme = this.props.theme;
        if (!this.props.useLargeTitles) {
            theme = mergeTheme(theme, [smallTitlesOverlay]);
        }

        if (this.props.updateTailwind === false) {
            return (
                <ThemeProvider theme={theme}>
                    <>{this.props.children}</>
                </ThemeProvider>
            );
        }

        return (
            <TailwindThemeProvider theme={theme}>
                <>{this.props.children}</>
            </TailwindThemeProvider>
        );
    }
}

export default withTheme(ThemeContainer);
